import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import * as S from './SiderMenu.styles';
import { sidebarNavigation, SidebarNavigationItem } from '../sidebarNavigation';
import { abilityService } from '@app/services/ability.service';

interface SiderContentProps {
  setCollapsed: (isCollapsed: boolean) => void;
}

const sidebarNavFlat = sidebarNavigation.reduce(
  (result: SidebarNavigationItem[], current) =>
    result.concat(current.children && current.children.length > 0 ? current.children : current),
  [],
);

const SiderMenu: React.FC<SiderContentProps> = ({ setCollapsed }) => {
  const { t } = useTranslation();
  const location = useLocation();

  const currentMenuItem = sidebarNavFlat.find(({ url }) => url === location.pathname);
  const defaultSelectedKeys = currentMenuItem ? [currentMenuItem.key] : [];

  const openedSubmenu = sidebarNavigation.find(({ children }) =>
    children?.some(({ url }) => url === location.pathname),
  );
  const defaultOpenKeys = openedSubmenu ? [openedSubmenu.key] : [];

  const abilities = abilityService.getAbilities();
  console.log(abilities);

  const handleMenuClick = (key: any) => {
    setCollapsed(true);

    const clickedItem = sidebarNavFlat.find((item) => item.key === key);

    // If cat_id exists, save it to localStorage
    if (clickedItem?.cat_id) {
      localStorage.setItem('selected_category_id', clickedItem.cat_id.toString());
    }
    if (clickedItem?.lab_type) {
      localStorage.setItem('selected_lab_type', String(clickedItem.lab_type));
    }
    if (clickedItem?.rep_type) {
      localStorage.setItem('selected_rep_type', String(clickedItem.rep_type));
    }
    if (clickedItem?.customer_type) {
      localStorage.setItem('selected_customer_type', String(clickedItem.customer_type));
    }
    if (clickedItem?.import_type) {
      localStorage.setItem('selected_import_type', String(clickedItem.import_type));
    }
    if (clickedItem?.pc_type) {
      localStorage.setItem('selected_pc_type', String(clickedItem.pc_type));
    }
  };

  return (
    <S.Menu
      mode="inline"
      defaultSelectedKeys={defaultSelectedKeys}
      defaultOpenKeys={defaultOpenKeys}
      onClick={({ key }) => handleMenuClick(key)}
      items={sidebarNavigation.map((nav) => {
        const isSubMenu = nav.children?.length;

        return (
          (abilities &&
            nav?.model &&
            nav?.policy &&
            abilities.hasOwnProperty(nav?.model) &&
            abilities[nav?.model].includes(nav?.policy) && {
              key: nav.key,
              title: t(nav.title),
              label: isSubMenu ? t(nav.title) : <Link to={nav.url || ''}>{t(nav.title)}</Link>,
              icon: nav.icon,
              children:
                isSubMenu &&
                nav.children &&
                nav.children.map(
                  (childNav) =>
                    abilities &&
                    childNav?.model &&
                    childNav?.policy &&
                    abilities.hasOwnProperty(childNav?.model) &&
                    abilities[childNav?.model].includes(childNav?.policy) && {
                      icon: childNav.icon,
                      key: childNav.key,
                      label: <Link to={childNav.url || ''}>{t(childNav.title)}</Link>,
                      title: t(childNav.title),
                      cat_id: childNav.cat_id,
                    },
                ),
            }) ||
          null
        );
      })}
    />
  );
};

export default SiderMenu;
